import React, { useEffect, useState } from 'react'
import writeXlsxFile from 'write-excel-file'
import Toast from '../toast';
import { toast } from 'react-toastify';

import _ from "lodash";
import cx from "classnames"
import styles from './styles.module.scss'
import Actions from '../actionbar';

interface IExportProps {
  schema: ISchema[],
  fetchDataForPage: (page: number) => void,
  fileName: string,
  title: string,
  pagination: {
    currentPage: number,
    totalPages: number,
    recordsPerPage: number,
    totalRecordsCount: number,
    hasMoreItems: boolean
  },
  invalidateData: () => void,
  data: any,
  fetchState: {
    loading: boolean,
    succeeded: boolean,
    error: any
  }
  handleClose?: () => void,
  downloadClick?: () => void
  /** When set with multiSheetData / multiSheetSchemas / multiSheetNames, writes multiple worksheets via write-excel-file */
  multiSheet?: boolean
  multiSheetData?: any[][]
  multiSheetSchemas?: ISchema[][]
  multiSheetNames?: string[]
}
interface ISchema {
  column: string,
  type: any,
  value: any
}



const DownloadExcel: React.FC<IExportProps> = (props) => {

  const schema = props.schema;
  const data = props.data;
  const isMultiSheet = props.multiSheet && _.size(props.multiSheetData) > 0;
  const fetchDataForPage = props.fetchDataForPage;
  const { hasMoreItems, currentPage, totalRecordsCount } = props.pagination;
  const { loading, succeeded, error } = props.fetchState;

  const [fetchData, setFetchData] = useState<boolean>(false);
  const [downloading, setDownloading] = useState<boolean>(false);
  const [downloadedPercentage, setDownloadedPercentage] = useState<number>(1);
  const [showToast, setShowToast] = useState<boolean>(false);

  useEffect(() => {

    if (fetchData && !error && !downloading && succeeded) {
      if (hasMoreItems && !loading) {
        fetchDataForPage(currentPage + 1)
      }
      else if (!hasMoreItems && !downloading) {
        triggerDownload();
      }

      let recordCount: number;
      if (isMultiSheet) {
        recordCount = _.sumBy(props.multiSheetData, (sheet) => _.size(sheet));
      } else {
        recordCount = _.size(data);
      }
      if (recordCount > 0) {
        var percentage = Math.floor(
          (recordCount / totalRecordsCount) * 100
        );
        setDownloadedPercentage(percentage)
      }
    }

    if (error) {
      invalidateDownloadData();
      toast(<Toast.Failure message={`Failed to download ${props.title}`} />, {
        autoClose: 3000
      })
    }

  }, [succeeded, error, isMultiSheet])

  useEffect(() => {
    
    return (() => {
      invalidateDownloadData();
    })
  },[])

  const triggerDownload = async () => {
    if (!downloading) {
      setDownloading(true)
      const writeOptions = isMultiSheet
        ? {
            schema: props.multiSheetSchemas,
            sheets: props.multiSheetNames,
            fileName: props.fileName,
          }
        : {
            schema,
            fileName: props.fileName,
          };
      const payload = isMultiSheet ? props.multiSheetData : data;
      await writeXlsxFile(payload as any, writeOptions as any).then(() => {
        setDownloading(false)
        invalidateDownloadData();
        if(props.handleClose){
          props.handleClose();
        }
        toast(<Toast.Sucess message={`${props.title} Downloaded Successfully`} />, {
          toastId: props.fileName,
        });
      }).catch((error) => {
        setDownloading(false)
        invalidateDownloadData();
        toast(<Toast.Failure message={`Failed to download ${props.title}`} />, {
          autoClose: 3000
        })
      })
    }
  }

  const handleDownloadClick = async () => {
    if (props.downloadClick) {
      props.downloadClick();
    }
    setShowToast(true)
  }

  const handleToastClose = () => {
    invalidateDownloadData();
  }

  const handleConfirmClick = () => {
    fetchDataForPage(0);
    setFetchData(true);
  }

  const invalidateDownloadData = () => {
    setFetchData(false)
    setShowToast(false)
    setDownloading(false)
    setDownloadedPercentage(1);
    props.invalidateData();
  }

  return (
    <div className={styles.downloadContainer}>
    
      <Actions.IconButton
        icon="paperflite-download"
        onClick={handleDownloadClick}
      />

      <div className={cx(styles.toast, {
        [styles.show]: showToast
      })}>
        <p className={styles.header}>would you like to export the
          <i onClick={handleToastClose} className={cx('paperflite-close',
            { [styles.disabled]: fetchData }
          )} /> </p>
        <p className={styles.title}>{props.title}</p>

        {!fetchData && <p onClick={handleConfirmClick} className={styles.confirm}><i className="paperflite-tick" /> Confirm </p>}
        
        {fetchData && <div className={styles.progressBar}>
          <div className={styles.progress} style={{ width: `${downloadedPercentage}%` }}></div>
        </div>}
      </div>
    </div>
  )
}

export default DownloadExcel;